import { UserException } from '@/domain/user/exception/UserException'

export class ForbiddenException extends UserException {

}
